import { apiClient } from "../client-api";
import { authHeader } from "@/_helpers";
import merge from "lodash/merge";
import appConfig from "@/app.config";

export default {
  async refresh(conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.get(appConfig.apiPath + "config/", conf);
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  }
};
